import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nanDefault'
})
export class NanDefaultPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
